<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Naptár</ion-title>
    <!-- EGY gombcsoport a slotban. Két külön `ion-buttons slot="end"` egymás melletti
         elhelyezése az eszköztárban nem garantált – a feliratkozás gomb felvételekor
         keletkezett második csoport elnyomhatta az „Új esemény"-t. Egy csoport,
         gombonkénti feltétellel: ez nem tud így elromlani. -->
    <ion-buttons slot="end">
      <ion-button (click)="feliratkozasNyitas()" title="Feliratkozás saját naptárba">
        <ion-icon slot="icon-only" name="calendar-outline"></ion-icon>
      </ion-button>
      <ion-button *ngIf="staffMode" (click)="rendeletBeemeles()" title="A tanév rendje – rendelet beemelése">
        <ion-icon slot="icon-only" name="library-outline"></ion-icon>
      </ion-button>
      <ion-button *ngIf="staffMode" (click)="sablonLetoltes()" title="Excel sablon letöltése">
        <ion-icon slot="icon-only" name="document-outline"></ion-icon>
      </ion-button>
      <ion-button *ngIf="staffMode" (click)="fileInput.click()" title="Excel import">
        <ion-icon slot="icon-only" name="cloud-upload-outline"></ion-icon>
      </ion-button>
      <ion-button *ngIf="staffMode" (click)="ujBejegyzes()">
        <ion-icon slot="start" name="add-circle"></ion-icon>
        Új esemény
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<input #fileInput type="file" hidden accept=".xlsx,.xls"
  (change)="importValtozas($event)" />

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-card>
          <ion-card-content>
            <p class="tervezo-tipp" *ngIf="staffMode">
              Új esemény: <strong>„+ Új esemény"</strong> gomb, vagy kattints a naptár egy napjára.
              A <b>saját</b> programjaidat szerkesztheted – amit te vettél fel, vagy aminek a
              felelőse vagy; a többit megnézni tudod.
            </p>
            <full-calendar [options]="calendarOptions"></full-calendar>
          </ion-card-content>
        </ion-card>

        <!-- Közelgő programok – kártyás lista -->
        <div class="program-szekcio" *ngIf="kozelgoEsemenyek.length">
          <h2 class="program-cim">A megjelenített időszak programjai</h2>
          <div class="program-grid">
            <div class="program-kartya" *ngFor="let e of kozelgoEsemenyek"
              [style.--accent]="tipusColor(e.tipus)" (click)="openKartya(e)">
              <div class="program-accent"></div>
              <div class="program-fej">
                <ion-icon [name]="e.ikon || tipusIcon(e.tipus)" [style.color]="tipusColor(e.tipus)"></ion-icon>
                <span class="program-tipus" [style.background]="tipusColor(e.tipus)">{{ tipusLabel(e.tipus) }}</span>
                <span class="program-jelentkezos" *ngIf="vanJelentkezes(e)">Jelentkezős</span>
                <span class="program-olvaso" *ngIf="staffMode && !szerkesztheto(e)" title="Nem te vetted fel, és nem is te vagy a felelőse">
                  <ion-icon name="lock-closed-outline"></ion-icon>csak olvasható
                </span>
              </div>
              <div class="program-nev">{{ e.nev }}</div>
              <div class="program-datum">
                <ion-icon name="time-outline"></ion-icon>
                <span *ngIf="e.egesz_napos">{{ e.kezdes | date:'yyyy.MM.dd' }}<span *ngIf="e.vege"> – {{ e.vege | date:'yyyy.MM.dd' }}</span></span>
                <span *ngIf="!e.egesz_napos">{{ e.kezdes | date:'yyyy.MM.dd HH:mm' }}</span>
              </div>
              <!-- A leírásban lévő cím kattintható, új ablakban nyílik (linkesit()). -->
              <div class="program-leiras" *ngIf="e.tema" [innerHTML]="e.tema_html"
                   (click)="linkKattintas($event)"></div>
              <div class="program-meta">
                <span class="program-chip" *ngIf="e.jelentkezheto && e.ar">{{ arSzoveg(e) }}</span>
                <span class="program-chip szabad" *ngIf="szabadHely(e) !== null">{{ szabadHely(e) }} szabad hely</span>
                <span class="program-chip" *ngIf="e.alprogramok?.length">{{ e.alprogramok.length }} program</span>
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- A lebegő „+” gomb kikerült: a jobb alsó sarokban Konrád nyuszi gombja ül. Új esemény a
       fejléc „+” gombjával vagy a napra kattintva vehető fel. -->
</ion-content>

<!-- ── Részletek + (szülő) jelentkezés ─────────────────────────────────── -->
<ion-modal #reszletekmodal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start"><ion-button (click)="closeReszletek()">Bezár</ion-button></ion-buttons>
        <ion-title>{{ f?.nev }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" *ngIf="f">
      <ion-chip [outline]="true">
        <ion-icon [name]="f.ikon || 'calendar'"></ion-icon>
        <ion-label>{{ tipusLabel(f.tipus) }}</ion-label>
      </ion-chip>
      <p>
        <strong>Időpont:</strong>
        <span *ngIf="f.egesz_napos">{{ f.kezdes | date:'yyyy.MM.dd' }} – {{ f.vege | date:'yyyy.MM.dd' }} (egész napos)</span>
        <span *ngIf="!f.egesz_napos">{{ f.kezdes | date:'yyyy.MM.dd HH:mm' }} – {{ f.vege | date:'yyyy.MM.dd HH:mm' }}</span>
      </p>
      <p *ngIf="f.tema"><strong>Leírás:</strong> <span [innerHTML]="f.tema_html"></span></p>
      <div class="dm-sav" *ngIf="staffMode && f.id && dmBejegyzesE(f)">
        <ion-icon name="laptop-outline"></ion-icon>
        <span>Tantermen kívüli, digitális munkarend – az elrendelt osztályok itt láthatók.</span>
        <ion-button size="small" fill="outline" color="tertiary" (click)="digitalisMunkarend(f)">Digitális munkarend</ion-button>
      </div>
      <p *ngIf="f.jelentkezheto && f.ar"><strong>Ár:</strong> {{ arSzoveg(f) }} <span *ngIf="f.ar_tipus">/ {{ f.ar_tipus }}</span></p>

      <!-- MUNKATÁRS, AKI NEM SZERKESZTHETI. Neki nem elég annyi, hogy „nem lehet":
           tudnia kell, KIHEZ forduljon, ha változtatni kell rajta. -->
      <div class="olvaso-indok" *ngIf="staffMode">
        <ion-icon name="lock-closed-outline"></ion-icon>
        <div>
          Ezt a bejegyzést csak megnézni tudod.
          <span *ngIf="felelosNev(f.felelos) && f.felelos">Felelőse: <b>{{ felelosNev(f.felelos) }}</b>. </span>
          <span *ngIf="f.szerzo">Felvette: <b>{{ felelosNev(f.szerzo) || f.szerzo }}</b>. </span>
          <span *ngIf="!f.szerzo && !f.felelos">Nincs megjelölve, ki vette fel – ilyet adminisztrátor tud módosítani. </span>
          Módosítást ő vagy egy adminisztrátor tud végezni.
        </div>
      </div>

      <div *ngIf="szuloMode && f.jelentkezheto">
        <h2>Jelentkezés</h2>
        <p *ngIf="!jelentkezesNyitva" class="ion-color-danger">A jelentkezési időszak jelenleg nem aktív.</p>
        <ion-list *ngIf="jelentkezesNyitva && gyerekek?.length">
          <ion-item *ngFor="let n of gyerekek" [color]="isJelentkezett(n.oktazon) ? 'success' : ''">
            <ion-label style="flex:1">{{ n.full_name || n.name }}</ion-label>
            <ion-button slot="end" size="default" (click)="setJelentkezes(n, false)"
              [color]="!isJelentkezett(n.oktazon) ? 'primary' : 'light'" [disabled]="!isJelentkezett(n.oktazon)">Nem</ion-button>
            <ion-button slot="end" size="default" (click)="setJelentkezes(n, true)"
              [color]="isJelentkezett(n.oktazon) ? 'primary' : 'light'" [disabled]="isJelentkezett(n.oktazon)">Jelentkezik</ion-button>
          </ion-item>
        </ion-list>
      </div>

      <!-- AL-PROGRAMOK: mindegyikre külön lehet jelentkezni, saját férőhellyel és árral. -->
      <div *ngIf="f.alprogramok?.length" class="alprogram-blokk">
        <h2>Programok</h2>
        <div class="alprogram-kartya" *ngFor="let a of f.alprogramok">
          <div class="alprogram-fej">
            <b>{{ a.nev }}</b>
            <span class="halvany">
              <ng-container *ngIf="a.egesz_napos">{{ a.kezdes | date:'yyyy.MM.dd' }}</ng-container>
              <ng-container *ngIf="!a.egesz_napos">{{ a.kezdes | date:'MM.dd HH:mm' }} – {{ a.vege | date:'HH:mm' }}</ng-container>
            </span>
          </div>
          <div class="halvany" *ngIf="a.tema" [innerHTML]="a.tema_html" (click)="linkKattintas($event)"></div>
          <div class="program-meta">
            <span class="program-chip" *ngIf="a.jelentkezheto && a.ar">{{ arSzoveg(a) }}<span *ngIf="a.ar_tipus"> / {{ a.ar_tipus }}</span></span>
            <span class="program-chip szabad" *ngIf="szabadHely(a) !== null">{{ szabadHely(a) }} szabad hely</span>
            <span class="program-chip" *ngIf="staffMode && a.jelentkezheto">{{ alJelentkezoDb(a) }} jelentkező</span>
          </div>
          <ng-container *ngIf="szuloMode && a.jelentkezheto">
            <p *ngIf="!nyitva(a)" class="ion-color-danger halvany">A jelentkezési időszak jelenleg nem aktív.</p>
            <ion-list *ngIf="nyitva(a) && gyerekek?.length">
              <ion-item *ngFor="let n of gyerekek" [color]="isAlJelentkezett(a, n.oktazon) ? 'success' : ''">
                <ion-label style="flex:1">{{ n.full_name || n.name }}</ion-label>
                <ion-button slot="end" size="default" (click)="setAlJelentkezes(a, n, false)"
                  [color]="!isAlJelentkezett(a, n.oktazon) ? 'primary' : 'light'" [disabled]="!isAlJelentkezett(a, n.oktazon)">Nem</ion-button>
                <ion-button slot="end" size="default" (click)="setAlJelentkezes(a, n, true)"
                  [color]="isAlJelentkezett(a, n.oktazon) ? 'primary' : 'light'" [disabled]="isAlJelentkezett(a, n.oktazon)">Jelentkezik</ion-button>
              </ion-item>
            </ion-list>
          </ng-container>
        </div>
      </div>
    </ion-content>

    <ion-footer class="modal-labjegyzet" *ngIf="f && szuloMode && barmiNyitva && gyerekek?.length">
      <ion-toolbar>
        <div class="modal-gombsor">
          <ion-button color="primary" (click)="jelentkez()">
            <ion-icon slot="start" name="save"></ion-icon> Jelentkezés mentése
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>

<!-- ── Dolgozói szerkesztő ──────────────────────────────────────────────── -->
<ion-modal #szerkesztomodal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start" *ngIf="ef?.szulo_id">
          <ion-button (click)="visszaSzulohoz()" title="Vissza a fő eseményhez">
            <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>{{ ef?.szulo_id ? (ef?.id ? 'Al-program szerkesztése' : 'Új al-program') : (ef?.id ? 'Esemény szerkesztése' : 'Új esemény') }}</ion-title>
        <ion-buttons slot="end"><ion-button (click)="closeSzerkeszto()"><ion-icon name="close"></ion-icon></ion-button></ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" *ngIf="ef">
      <!-- AL-PROGRAM: a hatókört, a publikálást és a felelősöket a fő eseménytől örökli. -->
      <div class="alprogram-sav" *ngIf="ef.szulo_id">
        <ion-icon name="git-branch-outline"></ion-icon>
        <span>
          Al-program: <b>{{ alSzuloNev || 'fő esemény' }}</b>. Hogy kit érint, publikus-e, és kik a felelősei,
          azt a fő eseménytől örökli – ott módosítható.
        </span>
      </div>
      <!-- A tanév rendje szerinti digitális munkarend (beemelt bejegyzés): innen indul az elrendelés. -->
      <div class="dm-sav" *ngIf="ef.id && dmBejegyzesE(ef)">
        <ion-icon name="laptop-outline"></ion-icon>
        <span>Tantermen kívüli, digitális munkarend – az igazgató döntése szerint, osztályonként rendelhető el.</span>
        <ion-button size="small" fill="solid" color="tertiary" (click)="digitalisMunkarend(ef)">Digitális munkarend elrendelése</ion-button>
      </div>
      <ion-list>
        <ion-item>
          <ion-input label="Megnevezés *" labelPlacement="stacked" [(ngModel)]="ef.nev"
            [placeholder]="ef.szulo_id ? 'pl. Robotika bemutató' : 'pl. Őszi szünet'"></ion-input>
        </ion-item>
        <ion-item *ngIf="!ef.szulo_id">
          <ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="ef.tipus" interface="popover">
            <ion-select-option *ngFor="let t of valaszthatoTipusok" [value]="t.value">{{ t.label }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-textarea label="Leírás" labelPlacement="stacked" [(ngModel)]="ef.tema" autoGrow="true" rows="2"></ion-textarea>
        </ion-item>
        <ion-item>
          <ion-toggle [(ngModel)]="ef.egesz_napos" (ngModelChange)="egeszNaposValt()">Egész napos</ion-toggle>
        </ion-item>
        <ion-item>
          <ion-input label="Kezdés *" labelPlacement="stacked" [type]="ef.egesz_napos ? 'date' : 'datetime-local'" [(ngModel)]="ef.kezdes"></ion-input>
        </ion-item>
        <ion-item>
          <ion-input label="Vége *" labelPlacement="stacked" [type]="ef.egesz_napos ? 'date' : 'datetime-local'" [(ngModel)]="ef.vege"></ion-input>
        </ion-item>

        <!-- TANÓRA-ALAPÚ IDŐZÍTÉS. A program nem 10:15-kor van, hanem a 3–5. órában:
             az időpont a csengetési rendből jön, tehát átszervezéskor együtt mozog vele. -->
        <ion-item>
          <ion-toggle [(ngModel)]="ef.ora_alapu" color="tertiary">Tanórához kötött (óra/perc helyett)</ion-toggle>
        </ion-item>
        <div *ngIf="ef.ora_alapu" class="ion-padding-start">
          <ion-item>
            <ion-input label="Ettől az órától" labelPlacement="stacked" type="number" min="0" max="12"
                       [(ngModel)]="ef.ora_tol"></ion-input>
            <ion-input label="Eddig az óráig" labelPlacement="stacked" type="number" min="0" max="12"
                       [(ngModel)]="ef.ora_ig"></ion-input>
          </ion-item>
          <ion-item lines="none">
            <ion-button size="small" fill="outline" (click)="oraIdopontBetolt()">
              <ion-icon slot="start" name="time-outline"></ion-icon>Időpont a csengetési rendből
            </ion-button>
          </ion-item>
          <ion-note class="ion-padding-start">
            Az órák megadásával a rendszer az órarendből leválogatja, <b>kik tanítanának</b> ekkor az
            érintett osztályokban – és nekik szól.
          </ion-note>
        </div>

        <ng-container *ngIf="!ef.szulo_id">
        <ion-item lines="none"><ion-label position="stacked">Kit érint?</ion-label></ion-item>
        <ion-item>
          <ion-segment [(ngModel)]="ef.scope_tipus" scrollable="true">
            <ion-segment-button value="intezmeny"><ion-label>Intézmény</ion-label></ion-segment-button>
            <ion-segment-button value="osztaly"><ion-label>Osztály(ok)</ion-label></ion-segment-button>
            <ion-segment-button value="csoport"><ion-label>Csoport(ok)</ion-label></ion-segment-button>
            <!-- Belső, munkatársaknak szóló program: értekezlet, oktatás, ügyelet. -->
            <ion-segment-button value="dolgozo"><ion-label>Dolgozók</ion-label></ion-segment-button>
          </ion-segment>
        </ion-item>

        <!-- DOLGOZÓI KÖR. Nem minden belső program szól mindenkinek: a tantestületi
             értekezlet a pedagógusoké, a munkavédelmi oktatás mindenkié. -->
        <ng-container *ngIf="ef.scope_tipus === 'dolgozo'">
          <ion-item>
            <ion-select label="Kikre tartozik?" labelPlacement="stacked" interface="popover"
                        [(ngModel)]="ef.dolgozoi_kor">
              <ion-select-option value="mind">Minden dolgozó</ion-select-option>
              <ion-select-option value="pedagogus">Csak a pedagógusok</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-note class="ion-padding-start halvany">
            A dolgozói programot <b>szülő és diák nem látja</b> – akkor sem, ha publikálva van.
            Pedagógusnak az számít, aki <b>tanít</b> (szerepel az órarendben tanárként vagy
            helyettesítőként) — nem a jogkör dönti el, mert az a menü-hozzáférést szabályozza.
            Akinek még nincs órája, azt vedd fel <b>névre szólóan</b> alább.
          </ion-note>
        </ng-container>
        <ion-item *ngIf="ef.scope_tipus === 'osztaly'">
          <ion-label position="stacked">Osztályok</ion-label>
          <ion-button slot="end" fill="outline" size="default" (click)="scopePickerNyitas('osztaly')">
            <ion-icon slot="start" name="search-outline"></ion-icon>
            {{ scopeOsszegzo() }}
          </ion-button>
        </ion-item>
        <ion-item *ngIf="ef.scope_tipus === 'csoport'">
          <ion-label position="stacked">Csoportok</ion-label>
          <ion-button slot="end" fill="outline" size="default" (click)="scopePickerNyitas('csoport')">
            <ion-icon slot="start" name="search-outline"></ion-icon>
            {{ scopeOsszegzo() }}
          </ion-button>
        </ion-item>
        </ng-container>

        <!-- NÉVRE SZÓLÓ ÉRINTETTEK: a hatókörön FELÜL, nem helyette. -->
        <ion-item>
          <ion-label position="stacked">Kit érint még? (névre szólóan)</ion-label>
          <ion-button slot="end" fill="outline" size="default" (click)="szemelyPickerNyitas()">
            <ion-icon slot="start" name="person-add-outline"></ion-icon>
            {{ szemelyOsszegzo() }}
          </ion-button>
        </ion-item>
        <ion-note class="ion-padding-start halvany">
          Aki itt szerepel, annak a naptárában akkor is ott a program, ha a hatókör egyébként
          nem érintené – és az értesítést is megkapja.
        </ion-note>

        <ng-container *ngIf="!ef.szulo_id">
        <ion-item>
          <ion-toggle [(ngModel)]="ef.publikalt" color="success">Publikálva (szülők / honlap)</ion-toggle>
        </ion-item>
        <ion-item *ngIf="ef.publikalt">
          <ion-toggle [(ngModel)]="ef.faliujsag" color="warning">Kiküldés a faliújságra is</ion-toggle>
        </ion-item>

        <ion-item>
          <ion-select label="Tanügyi naptár (ebéd / napló)" labelPlacement="stacked"
            [(ngModel)]="ef.holiday_tipus" interface="popover">
            <ion-select-option *ngFor="let h of holidayTipusok" [value]="h.value">{{ h.label }}</ion-select-option>
          </ion-select>
        </ion-item>
        <!-- Munkaszüneti nap / iskolai szünet: a mentés a nap(ok) összes óráját törli, visszaállíthatóan. -->
        <ion-note class="ion-padding-start halvany" *ngIf="szunnapTipus || szunnapOrak?.torolt_orak">
          <ng-container *ngIf="szunnapTipus && !szunnapOrak?.torolt_orak">Mentéskor a nap(ok) összes órája törlődik (a 0. óra és a már beírt óra is). A törölt órák innen visszaállíthatók.</ng-container>
          <ng-container *ngIf="szunnapOrak?.torolt_orak">
            Ez a bejegyzés {{ szunnapOrak?.napok }} napról {{ szunnapOrak?.torolt_orak }} órát törölt.
            <ion-button size="small" fill="outline" (click)="szunnapOrakVisszaallitasa()" [disabled]="szunnapFut">Órák visszaállítása</ion-button>
          </ng-container>
        </ion-note>

        <!-- AUTOMATIKUS EBÉDLEMONDÁS. A program napjain az érintett tanulók ebédje
             lemondódik, és az étkezés-felületen az a nap nem kérhető újra. Csak jövőbeli,
             még nem számlázott programnál állítható át (a kiszolgáló is ellenőrzi). -->
        <ng-container *ngIf="ef.scope_tipus !== 'dolgozo'">
          <ion-item>
            <ion-toggle [(ngModel)]="ef.ebed_lemondas" color="warning"
                        [disabled]="!!ebedTiltasOka()" (ngModelChange)="ebedElonezetBetolt()">
              Ebéd automatikus lemondása az érintett tanulóknak
            </ion-toggle>
          </ion-item>
          <ion-note class="ion-padding-start halvany">
            <ng-container *ngIf="ebedTiltasOka() as ok; else ebedLeiras"><b>{{ ok }}</b></ng-container>
            <ng-template #ebedLeiras>
              A program napjain a rendszer lemondja az érintettek ebédjét, és az étkezés-felületen
              azt a napot <b>zárolja</b> („Iskolai program: …"). Kikapcsoláskor csak az áll vissza,
              amit a rendszer mondott le – amit a szülő maga mondott le, az lemondva marad.
              Jelentkezős programnál csak a <b>jelentkezettek</b> érintettek.
            </ng-template>
            <span *ngIf="ebedFut"> Számolás…</span>
            <span *ngIf="!ebedFut && ebedInfo">
              <br>Érintett: <b>{{ ebedInfo.tanulo_db }}</b> tanuló, {{ ebedInfo.nap_db }} jövőbeli nap,
              ebből most <b>{{ ebedInfo.rendeles_db }}</b> megrendelt ebéd<span *ngIf="ebedInfo.lemondott_db">;
              a rendszer eddig <b>{{ ebedInfo.lemondott_db }}</b> ebédet mondott le</span>.
            </span>
          </ion-note>
        </ng-container>
        </ng-container>

        <!-- ÉRTESÍTÉS. Az érintettek listája az órarendből jön, ezért itt látszik is,
             kinek megy majd – vakon értesítést küldeni nem szabad. -->
        <ion-item lines="none"><ion-label position="stacked">Értesítés az érintetteknek</ion-label></ion-item>
        <ion-item>
          <ion-select label="Előre szólunk" labelPlacement="stacked" interface="popover"
                      [(ngModel)]="ef.ertesites_elore_ora">
            <ion-select-option [value]="null">nem</ion-select-option>
            <ion-select-option [value]="1">1 órával korábban</ion-select-option>
            <ion-select-option [value]="3">3 órával korábban</ion-select-option>
            <ion-select-option [value]="24">24 órával korábban</ion-select-option>
            <ion-select-option [value]="48">2 nappal korábban</ion-select-option>
            <ion-select-option [value]="168">1 héttel korábban</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-toggle [(ngModel)]="ef.ertesites_aznap" color="warning">Aznap reggel is</ion-toggle>
        </ion-item>
        <!-- MELYIK ÚTON SZÓLUNK. A belső üzenet csak azt éri el, aki belép; egy holnapi
             programnál viszont az a kérdés, hogy ma este elolvassa-e valaki. -->
        <ion-item>
          <ion-select label="Hogyan szóljunk?" labelPlacement="stacked" interface="popover"
                      [(ngModel)]="ef.ertesites_csatorna">
            <ion-select-option value="uzenet">Belső üzenet</ion-select-option>
            <ion-select-option value="email">E-mail</ion-select-option>
            <ion-select-option value="mind">E-mail és belső üzenet is</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-note class="ion-padding-start halvany" *ngIf="ef.ertesites_csatorna === 'email'">
          Akinek nincs e-mail címe a törzsadatban – vagy akinél a levél elakad –,
          az <b>belső üzenetet</b> kap helyette, hogy senki ne maradjon értesítés nélkül.
        </ion-note>

        <!-- Felelősök: ők szervezik, szerkeszthetik a bejegyzést, és az értesítést
             akkor is megkapják, ha épp nincs órájuk az esemény idején. TÖBBEN is
             lehetnek – két kísérő tanár, szervező + szakmai felelős. -->
        <ng-container *ngIf="!ef.szulo_id">
        <ion-item>
          <ion-label position="stacked">Felelős(ök)</ion-label>
          <ion-button slot="end" fill="outline" size="default" (click)="felelosPickerNyitas()">
            <ion-icon slot="start" name="people-outline"></ion-icon>
            {{ felelosOsszegzo() }}
          </ion-button>
        </ion-item>
        <ion-note class="ion-padding-start halvany">
          A felelős <b>szerkesztheti</b> a bejegyzést akkor is, ha nem ő vette fel, és
          megkapja az értesítést akkor is, ha épp nincs órája az esemény idején.
        </ion-note>
        </ng-container>

        <div class="ion-padding-start" *ngIf="ef.id">
          <ion-item lines="none">
            <ion-label>
              <span *ngIf="erintettFut">Érintettek keresése az órarendben…</span>
              <span *ngIf="!erintettFut && erintett">
                <b>{{ erintett.tanarok.length }}</b> tanár ({{ erintett.ora_db }} óra) és
                <b>{{ erintett.tanulok.length }}</b> tanuló érintett
              </span>
              <!-- Az előnézet a MENTETLEN állapotra vonatkozik: mondjuk is ki, hogy a
                   szám csak akkor lesz végleges, ha a bejegyzést elmented. -->
              <div class="halvany" *ngIf="!erintettFut && erintett?.mentetlen">
                Ez az <b>el nem mentett</b> beállításokra vonatkozik — mentés után lesz végleges.
              </div>
              <span *ngIf="!erintettFut && !erintett">Még nem néztük meg, kit érint.</span>
              <div class="halvany" *ngIf="ef.jelentkezheto">
                Jelentkezéses esemény: a tanulók közül csak a <b>jelentkezettek</b> érintettek,
                nem a teljes hatókör.
              </div>
            </ion-label>
            <ion-button slot="end" size="small" fill="outline" (click)="erintettBetolt()" [disabled]="erintettFut">
              Kik érintettek?
            </ion-button>
          </ion-item>
          <ion-item lines="none" *ngIf="erintett?.tanarok?.length">
            <ion-label class="erintett-lista">
              <div *ngFor="let t of erintett.tanarok">
                <b>{{ t.nev }}</b>
                <span *ngIf="t.felelos" class="jel">felelős</span>
                <span *ngIf="t.helyettesitokent" class="jel">helyettesítőként</span>
                <span class="halvany">
                  – <span *ngFor="let o of t.orak; let i = index">{{ i ? ', ' : '' }}{{ o.ora }}. óra {{ o.osztaly }}</span>
                </span>
              </div>
            </ion-label>
          </ion-item>
          <ion-item lines="none" *ngIf="erintett?.kuldott?.length">
            <ion-label class="halvany">
              Kiküldve:
              <span *ngFor="let k of erintett.kuldott; let i = index">{{ i ? ', ' : '' }}{{ k.fajta }}
                ({{ k.tanar_db }} tanár, {{ k.tanulo_db }} tanuló)</span>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-button size="small" color="warning" (click)="ertesitestKuld()"
                        [disabled]="kuldesFut || !erintett">
              <ion-icon slot="start" name="send-outline"></ion-icon>Értesítés kiküldése most
            </ion-button>
          </ion-item>
        </div>

        <ion-item>
          <ion-toggle [(ngModel)]="ef.jelentkezheto" color="tertiary">Jelentkezni lehet rá</ion-toggle>
        </ion-item>
        <div *ngIf="ef.jelentkezheto" class="ion-padding-start">
          <ion-item><ion-input label="Férőhely (létszám)" labelPlacement="stacked" type="number" [(ngModel)]="ef.letszam"></ion-input></ion-item>
          <ion-item><ion-input label="Minimum létszám" labelPlacement="stacked" type="number" [(ngModel)]="ef.minimum"></ion-input></ion-item>
          <ion-item><ion-input label="Jelentkezés ettől" labelPlacement="stacked" type="date" [(ngModel)]="ef.jelentkezes_tol"></ion-input></ion-item>
          <ion-item><ion-input label="Jelentkezés eddig" labelPlacement="stacked" type="date" [(ngModel)]="ef.jelentkezes_ig"></ion-input></ion-item>
          <!-- Az ár és a pénzneme egy sorban: a sítábor euróban van, a napközis tábor forintban. -->
          <ion-item>
            <ion-input label="Ár" labelPlacement="stacked" type="number" min="0" [(ngModel)]="ef.ar"></ion-input>
            <ion-select slot="end" class="ar-penznem" label="Pénznem" labelPlacement="stacked" interface="popover"
                        [(ngModel)]="ef.ar_penznem">
              <ion-select-option *ngFor="let p of penznemek" [value]="p.kod">{{ p.kod }} ({{ p.jel }})</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngIf="ef.id">
            <ion-label>Jelentkezők: <strong>{{ szerkesztoJelentkezok.length }}</strong><span *ngIf="ef.letszam"> / {{ ef.letszam }}</span></ion-label>
            <ion-button slot="end" fill="outline" size="small" (click)="nevsorPdf()" [disabled]="!szerkesztoJelentkezok.length">
              <ion-icon slot="start" name="download"></ion-icon> Névsor (PDF)
            </ion-button>
          </ion-item>
          <!-- Szakkör a jelentkezőkből: nem tanórai csoport + órák az órarendben (tkt-orarend.js). -->
          <ion-item *ngIf="ef.id && szerkesztheto(ef)" lines="none">
            <ion-label class="ion-text-wrap"><small>A jelentkezőkből rendes, nem tanórai célú szakkör lehet az órarendben.</small></ion-label>
            <ion-button slot="end" fill="outline" size="small" (click)="orarendbeEmel()" [disabled]="!szerkesztoJelentkezok.length">
              <ion-icon slot="start" name="calendar-number-outline"></ion-icon> Átemelés az órarendbe
            </ion-button>
          </ion-item>
        </div>

        <!-- AL-PROGRAMOK (pl. nyílt nap: több, külön jelentkezhető foglalkozás saját
             időponttal, férőhellyel, árral). Csak a fő eseménynél – egy szint van. -->
        <ng-container *ngIf="!ef.szulo_id">
          <ion-item lines="none">
            <ion-label position="stacked">Al-programok</ion-label>
            <ion-button slot="end" fill="outline" size="small" (click)="ujAlprogram()" [disabled]="!ef.id">
              <ion-icon slot="start" name="add"></ion-icon> Új al-program
            </ion-button>
          </ion-item>
          <ion-note class="ion-padding-start halvany" *ngIf="!ef.id">
            Al-programot (pl. a nyílt nap egyes foglalkozásait) az esemény mentése után vehetsz fel.
          </ion-note>
          <ion-note class="ion-padding-start halvany" *ngIf="ef.id && !ef.alprogramok?.length">
            Ha az eseményen belül több program van, amelyekre <b>külön</b> lehet jelentkezni
            (saját időponttal, férőhellyel, árral), itt veheted fel őket.
          </ion-note>
          <div class="alprogram-lista" *ngIf="ef.alprogramok?.length">
            <ion-item *ngFor="let a of ef.alprogramok" button detail="true" (click)="alprogramSzerkeszt(a)">
              <ion-checkbox slot="start" [(ngModel)]="alPdfKi[a.id]" (click)="$event.stopPropagation()"
                            title="Benne legyen a névsor-PDF-ben"></ion-checkbox>
              <ion-label class="ion-text-wrap">
                <b>{{ a.nev }}</b>
                <p>
                  <ng-container *ngIf="a.egesz_napos">{{ a.kezdes | date:'yyyy.MM.dd' }}</ng-container>
                  <ng-container *ngIf="!a.egesz_napos">{{ a.kezdes | date:'yyyy.MM.dd HH:mm' }} – {{ a.vege | date:'HH:mm' }}</ng-container>
                  <span *ngIf="a.jelentkezheto">, {{ alJelentkezoDb(a) }}<span *ngIf="a.letszam"> / {{ a.letszam }}</span> jelentkező</span>
                  <span *ngIf="a.jelentkezheto && a.ar">, {{ arSzoveg(a) }}</span>
                  <span *ngIf="!a.jelentkezheto">, nem jelentkezős</span>
                </p>
              </ion-label>
            </ion-item>
            <ion-item lines="none">
              <ion-toggle [(ngModel)]="alPdfKulonOldal">Programonként új oldalon</ion-toggle>
            </ion-item>
            <ion-item lines="none">
              <ion-button size="small" fill="clear" (click)="alPdfMind(true)">Mind</ion-button>
              <ion-button size="small" fill="clear" (click)="alPdfMind(false)">Egyik sem</ion-button>
              <ion-button slot="end" fill="outline" size="small" (click)="alprogramPdf()" [disabled]="!alPdfValasztottDb">
                <ion-icon slot="start" name="download"></ion-icon> Névsor (PDF) – {{ alPdfValasztottDb }} program
              </ion-button>
            </ion-item>
          </div>
        </ng-container>
      </ion-list>

    </ion-content>

    <!-- A MENTÉS NEM AZ ŰRLAP UTOLSÓ SORA, HANEM A KÉPERNYŐ ALJA.
         Korábban a gombok a görgethető tartalom végén ültek: új eseménynél (ahol a
         Törlés sem különítette el őket) egybeolvadtak az utolsó űrlapsorral, és egy
         huszonöt mezős űrlap aljáig le kellett görgetni ahhoz, hogy egyáltalán
         látszódjanak. Rögzített lábban mindig ott van, és el is válik az űrlaptól. -->
    <ion-footer class="modal-labjegyzet" *ngIf="ef">
      <ion-toolbar>
        <div class="modal-gombsor">
          <ion-button *ngIf="ef.id" color="danger" fill="outline" (click)="torles()">
            <ion-icon slot="start" name="trash"></ion-icon> Törlés
          </ion-button>
          <ion-button color="primary" (click)="mentes()">
            <ion-icon slot="start" name="save"></ion-icon> Mentés
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>

<!-- ── Feliratkozás saját naptárba ──────────────────────────────────────── -->
<ion-modal #feliratkozasmodal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start"><ion-button (click)="feliratkozasmodal.dismiss()">Bezár</ion-button></ion-buttons>
        <ion-title>Feliratkozás saját naptárba</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-note color="medium" style="display:block;margin-bottom:14px">
        A programokat eddig kézzel kellett átvezetni a telefonod naptárába — ami egyszeri
        művelet, tehát a <b>későbbi változásról</b> (elmaradt program, áthelyezett időpont)
        már nem tudtál. Ha ezekre a címekre <b>feliratkozol</b>, a naptárad magától követi
        a változásokat.
      </ion-note>

      <div *ngIf="linkFut"><ion-spinner name="dots"></ion-spinner> Címek előkészítése…</div>

      <ng-container *ngIf="linkek">
        <div class="ical-link">
          <h3>Minden program</h3>
          <p>Az intézmény <b>közzétett</b> eseményei. Ez a cím nem tartalmaz személyes adatot,
             tehát megosztható — akár a honlapra is kitehető.</p>
          <div class="ical-cim">
            <code>{{ teljesCim(linkek.mind) }}</code>
            <ion-button size="small" fill="outline" (click)="masol(linkek.mind)">
              <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás
            </ion-button>
          </div>
        </div>

        <div class="ical-link">
          <h3>Csak ami rám tartozik</h3>
          <p *ngIf="szuloMode">A gyermeked <b>osztályára és csoportjaira</b> szóló, valamint az
             egész iskolának szóló közzétett programok.</p>
          <p *ngIf="diakMode">A <b>saját osztályodra és csoportjaidra</b> szóló, valamint az egész
             iskolának szóló közzétett programok.</p>
          <p *ngIf="staffMode">Az intézményi programok, amiknek <b>te vagy a szerzője vagy
             felelőse</b>, az általad tanított osztályok/csoportok eseményei, a <b>rád tartozó
             dolgozói programok</b>, és amikre <b>névre szólóan</b> fel vagy véve.</p>
          <div class="ical-cim">
            <code>{{ teljesCim(linkek.sajat) }}</code>
            <ion-button size="small" fill="outline" (click)="masol(linkek.sajat)">
              <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás
            </ion-button>
          </div>
        </div>

        <!-- BEÁGYAZHATÓ NÉZET. A .ics a naptáralkalmazásnak való; egy Teams-fül vagy egy
             SharePoint-oldal weblapot vár. Ugyanaz a kulcs, ugyanaz a szűrés. -->
        <div class="ical-link" *ngIf="linkek.sajat_nezet">
          <h3>Beágyazható nézet (Teams, SharePoint)</h3>
          <p>Ugyanez <b>weblapként</b>, ugyanazzal a szűréssel — ezt lehet Teams-fülbe vagy
             SharePoint-oldalba ágyazni. A <b>személyes</b> változat azt mutatja, ami rád
             tartozik; a <b>mindenkis</b> a közzétett programokat, dolgozói kör nélkül.</p>
          <div class="ical-cim">
            <code>{{ teljesCim(linkek.sajat_nezet) }}</code>
            <ion-button size="small" fill="outline" (click)="masol(linkek.sajat_nezet)">
              <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás
            </ion-button>
          </div>
          <div class="ical-cim" *ngIf="linkek.mind_nezet">
            <code>{{ teljesCim(linkek.mind_nezet) }}</code>
            <ion-button size="small" fill="outline" (click)="masol(linkek.mind_nezet)">
              <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás
            </ion-button>
          </div>
        </div>

        <ion-note color="warning" style="display:block;margin:14px 0">
          <b>A cím maga a belépés.</b> Egy külső naptár nem tud bejelentkezni, ezért a címben
          egy hosszú, véletlen kulcs van: <b>aki megkapja a linket, látja a tartalmát</b>. A
          személyes címet ezért ne oszd meg. Ha kikerült, kérj újat — a régi azonnal
          érvénytelenné válik.
        </ion-note>

        <ion-button fill="outline" color="danger" size="small" [disabled]="linkFut" (click)="ujraLink()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Új címeket kérek
        </ion-button>

        <div class="ical-sugo">
          <h3>Hogyan add hozzá</h3>
          <p><b>Google Naptár:</b> Egyéb naptárak <b>+</b> → Feliratkozás URL-ről → illeszd be a címet.</p>
          <p><b>Outlook / Microsoft 365:</b> Naptár hozzáadása → Feliratkozás az internetről.</p>
          <p><b>iPhone / iPad:</b> Beállítások → Naptár → Fiókok → Fiók hozzáadása → Egyéb →
             Feliratkozás naptárra.</p>
          <ion-note color="medium" style="display:block;font-size:12px">
            A naptáralkalmazások néhány óránként kérdeznek rá — egy frissen felvett program tehát
            nem azonnal, hanem rövid késéssel jelenik meg.
          </ion-note>
        </div>
      </ng-container>
    </ion-content>
  </ng-template>
</ion-modal>
